<div class="collaboration-settings">
    <div class="settings-row">
        <span>{{
            'containerSettings.visibilitySettings.title' | translate
        }}</span>
        <div class="radio-group">
            <label
                *ngFor="let option of visibilityOptions"
                [ngClass]="{ selected: selectedVisibility === option }"
                [id]="'visibility-radio-button-' + option"
                [title]="
                    'containerSettings.visibilitySettings.tooltips.' + option
                        | translate
                "
            >
                <input
                    type="radio"
                    name="visibility"
                    [checked]="selectedVisibility === option"
                    (change)="onVisibilityChange(option)"
                />
                <span class="custom-radio"></span>
                <span class="option-text">
                    {{
                        'containerSettings.visibilitySettings.options.' + option
                            | translate
                    }}
                </span>
            </label>
        </div>
    </div>
    <div class="settings-row">
        <span>{{
            'containerSettings.accessibilitySettings.title' | translate
        }}</span>
        <div class="radio-group">
            <label
                *ngFor="let option of accessibilityOptions"
                [ngClass]="{ selected: selectedAccessibility === option }"
                [id]="'accessibility-radio-button-' + option"
                [title]="
                    'containerSettings.accessibilitySettings.tooltips.' + option
                        | translate
                "
            >
                <input
                    type="radio"
                    name="accessibility"
                    [checked]="selectedAccessibility === option"
                    (change)="onAccessibilityChange(option)"
                />
                <span class="custom-radio"></span>
                <span class="option-text">
                    {{
                        'containerSettings.accessibilitySettings.options.' +
                            option | translate
                    }}
                </span>
            </label>
        </div>
    </div>
</div>
